import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import UserChatGallery from '../components/UserChatGallery';
import CustomSliderMessage from '../components/CustomSliderMessage';
import rightarrow from '../assets/images/right.svg';
import drop_vertical from '../assets/images/drop_vertical.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import loaderIcon from '../assets/images/loader.gif';
import verified from '../assets/images/verified.svg';
import config from '../config/config';

const ChatGallery = () => {
const { user_id } = useParams();
const scrollableDivRef = useRef(null);  
const { user_id: receiverId } = useParams();
const [userData, setUserData] = useState({ email: '', user_name: '' });
const [users, setUsers] = useState([]);
const [priority, setPriorityUsers] = useState([]); 
const [unread, setUnreadUsers] = useState([]);   
const [isSearchVisible, setSearchVisible] = useState(false);
const [isSearchVisibleChat, setSearchVisibleChat] = useState(false);
const [loading, setLoading] = useState(true);
const [chatHistory, setChatHistory] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [filter, setFilter] = useState('all');
const [sortedUsersalldelete, setSortedUsersallDelete] = useState([]);
const [receiverDetails, setReceiverDetails] = useState({});
const [mediaGallery, setMediaGallery] = useState([]);
const [toastMessage, setToastMessage] = useState('');
const [toastType, setToastType] = useState('');
const navigate = useNavigate();
const [messageContent, setMessageContent] = useState("");
const [filteredMessages, setFilteredMessages] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
  const chatUser = receiverDetails ? {
    id: receiverDetails.user_id,
    name: receiverDetails.name,
    user_name: receiverDetails.user_name,
    profile: receiverDetails.profile,
    online_status: receiverDetails.online_status,
    message_notification_status: receiverDetails.message_notification_status
  } : null;

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const fetchChatUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=all`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsers inside useEffect
useEffect(() => {
  fetchChatUsers();
}, [filter, navigate]);



const fetchChatHistory = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    try {
      const response = await axios.get(`${config.baseURL}/get-messages`, {
        params: { user_id },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        setChatHistory(response.data.messages);
        setReceiverDetails(response.data.receiver_details);
        setFilteredMessages(response.data.messages);
      }
    } catch (error) {
        console.error("Error fetching chat history:", error);
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    fetchChatHistory();
  }, [user_id]);


// Sort users based on the selected filter
  const sortedUsersall = users
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
    });


const fetchChatUsersPriority = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=priority`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPriorityUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsersPriority inside useEffect
useEffect(() => {
  fetchChatUsersPriority();
}, [filter, navigate]);


// Sort users based on the selected filter
  const sortedUserspriority = priority
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
    });


  const priorityCount = priority.length;

const fetchChatUsersUnread = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=unread`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUnreadUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsersUnread inside useEffect
useEffect(() => {
  fetchChatUsersUnread();
}, [filter, navigate]);



// Sort users based on the selected filter
  const sortedUsersunread = unread
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
    });

  const unreadCount = unread.length;


  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const toggleSearch = () => {
    setSearchVisible(!isSearchVisible);
  };

  const closeSearch = () => {
    setSearchVisible(false);
  };


  const toggleSearchChat = () => {
    setSearchVisibleChat(!isSearchVisibleChat);
  };

  const closeSearchChat = () => {
    setSearchVisibleChat(false);
  };

  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  const handleUserClick = (user_id) => {
    navigate(`/chatmessage/${user_id}`); 
  };

const handleMarkAllAsRead = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    await axios.post(`${config.baseURL}/message/mark-all-read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    // Fetch the updated list of users or notifications
    const response = await axios.get(`${config.baseURL}/chatable-users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setUsers(response.data.chat_users || []);
    setLoading(false);
  } catch (err) {
    console.error('Error marking all as read:', err.response ? err.response.data : err.message);
  }
};

const formatMessageTime = (messageTime) => {
  const now = new Date();
  const messageDate = new Date(messageTime);

  // Check if the message is from today
  const isToday = messageDate.toDateString() === now.toDateString();

  // Check if the message is from yesterday
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = messageDate.toDateString() === yesterday.toDateString();

  if (isToday) {
    // Format as "10:15 AM" or "10:15 PM"
    return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  } else if (isYesterday) {
    return "Yesterday";
  } else {
    // Format as "Feb 13"
    return messageDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
};


const handleClearMessage = async (userId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${config.baseURL}/clear-message`, {
            params: {
                receiver_id: userId,
            },
            headers: {
                Authorization: `Bearer ${token}`, // Replace `yourToken` with the actual token variable
            },
        });

        if (response.status === 200) {
            // Successfully cleared the message, now update the state
            setSortedUsersallDelete(prevUsers =>
                prevUsers.map(user =>
                    user.user_id === userId ? { ...user, last_message: "" } : user
                )
            );
            // Fetch chat users to reflect the updated list
            fetchChatUsers();
            fetchChatUsersPriority();
            fetchChatUsersUnread();
        }
    } catch (error) {
        console.error("Failed to clear the message", error);
    }
};
  
  return (
    <div>

      <div className="main_patreonpass_wrapper">

      {toastMessage && (
        <div className={`toast-message ${toastType}`}>
          {toastMessage}
        </div>
      )}

        <div className="patreonpass_container chat_message_history_wrap">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="chat_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>Messages</h1>
                  </div>
                   <div className="create_post_btn">
                          <button
                            className="create_post_btn_area verify_btn search_btn_chat"
                            id="searchButton"
                            onClick={toggleSearch}
                          >
                            <svg
                              className="heading_search_icon"
                              width={38}
                              height={38}
                              viewBox="0 0 38 38"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                stroke="#242529"
                                strokeWidth="3.88235"
                              />
                              <path
                                d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                fill="#242529"
                              />
                            </svg>

                          </button>

                          <Link to="/chatsend" className="create_post_btn_area verify_btn search_btn_chat chat_start">
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 27.5H49" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M27.5 49V6" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </Link>  

                        </div>
                        {isSearchVisible && (
                          <div id="searchContainer" className="collection_search">
                            <button
                              id="closeButton"
                              className="create_post_btn_area verify_btn search_btn_chat close_btn_search_after"
                              onClick={closeSearch}
                            >
                              <svg
                                width={54}
                                height={54}
                                viewBox="0 0 54 54"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 49L49 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M49 49L5 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              id="searchInput"
                              placeholder="Search"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button>
                              <svg
                                className="heading_search_icon"
                                width={38}
                                height={38}
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                  stroke="#00aff0"
                                  strokeWidth="3.88235"
                                />
                                <path
                                  d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                  fill="#00aff0"
                                />
                              </svg>
                            </button>
                          </div>
                        )}
                </div>

                
                <div className="chat_message_block">
                    <div className="post_top_section_head">
                      <div className="title_post_head">NEWEST FIRST</div>
                      <div className="title_post_head_shorting">
                        <div className="shorting_icons my_profile_menu">
                          <a
                            href="#"
                            className="shorting_lists"
                            id="productsDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <svg
                              width={54}
                              height={54}
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 44H15.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 27H32.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 10H49.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                          <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="all"
                                  name="status"
                                  checked={filter === 'all'}
                                  onChange={() => setFilter('all')}
                                />
                                <label htmlFor="all" className="dropdown-item">
                                  All
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="newest"
                                  name="status"
                                  checked={filter === 'newest'}
                                  onChange={() => setFilter('newest')}
                                />
                                <label htmlFor="newest" className="dropdown-item">
                                  Newest First
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="oldest"
                                  name="status"
                                  checked={filter === 'oldest'}
                                  onChange={() => setFilter('oldest')}
                                />
                                <label htmlFor="oldest" className="dropdown-item">
                                  Oldest First
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="mark-all-read"
                                  name="status"
                                />
                                <label
                                  htmlFor="mark-all-read"
                                  className="dropdown-item"
                                  onClick={handleMarkAllAsRead}
                                >
                                  Mark all as read
                                </label>
                              </li>
                            </ul>
                        </div>
                      </div>
                    </div>
                    
                    <div className="chat_pills">
                      <div className="pill_tabs">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link active"
                              id="pills-all-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-all"
                              type="button"
                              role="tab"
                              aria-controls="pills-all"
                              aria-selected="true"
                            >
                              All
                            </button>
                          </li>
                          {priorityCount > 0 && (
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="pills-following-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-following"
                              type="button"
                              role="tab"
                              aria-controls="pills-following"
                              aria-selected="false"
                              tabIndex={-1}
                            >
                              {" "}
                               Priority <span className="countdown">{priorityCount}</span>
                            </button>
                          </li>
                          )}
                           {unreadCount > 0 && (
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="pills-trending-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-trending"
                              type="button"
                              role="tab"
                              aria-controls="pills-trending"
                              aria-selected="false"
                              tabIndex={-1}
                            >
                              Unread <span className="countdown">{unreadCount}</span>
                            </button>
                          </li>
                           )}
                        </ul>
                      </div>
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade active show"
                          id="pills-all"
                          role="tabpanel"
                          aria-labelledby="pills-all-tab"
                        >
                          {/* Content for All */}
                          <div className="chat_user_list">
                              {loading ? (
                                <p>Loading...</p>
                              ) : sortedUsersall.length > 0 ? (
                                sortedUsersall
                                  .filter((user) =>
                                    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    user.username.toLowerCase().includes(searchTerm.toLowerCase())
                                  )
                                  .map((user) => (
                                  <Link
                                      to={`/chatmessage/${user.user_id}`}
                                      className={`chate_user_block ${
                                        (user.seen === "true" && !user.is_auth_user_message) || user.is_auth_user_message ? "seen" : ""
                                      }`}
                                      key={user.user_id}
                                    >
                                    <div className="client-img">
                                      <div className="lazy-container user_image">
                                        <div className={user.user_online_status === 'online' ? 'user_online_status online' : ''}>
                                          {user.profile ? (
                                            <img src={user.profile} alt={`${user.name} Image`} />
                                          ) : (
                                            <div className="user_initials">
                                             {getInitials(user.name)} 
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="chat_message_inside_list">
                                      <div className="chat_message_top_right">
                                        <div className="chat_message_top_right_left">
                                          <span>{user.name} <img src={verified} /></span>
                                          <span className="chat_username"> @{user.username} </span>
                                        </div>
                                        <div className="chat_message_top_right_right">
                                          <div className="close_icon_chat" onClick={(e) => {
                                              e.preventDefault(); 
                                              handleClearMessage(user.user_id);
                                          }}>
                                            <svg
                                              width={54}
                                              height={54}
                                              viewBox="0 0 54 54"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M5 49L49 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M49 49L5 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat_message_bottom_right">
                                        <div className="chat_message_bottom_right_left">
                                          <ul className="list_below_name chat-inside-list">
                                            {user.media && user.media.length > 0 && !user.last_message && (
                                              <li>
                                                <svg
                                                  className="img-inside_chate"
                                                  width={38}
                                                  height={38}
                                                  viewBox="0 0 38 38"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                                    fill="#242529"
                                                  />
                                                  <circle
                                                    cx="2.7766"
                                                    cy="2.7766"
                                                    r="2.7766"
                                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                                    fill="#242529"
                                                  />
                                                  <path
                                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                                    stroke="#242529"
                                                    strokeWidth="3.39362"
                                                    strokeLinecap="round"
                                                  />
                                                </svg>
                                                Media Attached
                                              </li>
                                            )}
                                            {user.last_message && (
                                              <li>{user.last_message}</li>
                                            )}
                                          </ul>
                                        </div>
                                        <div className="chat_message_bottom_right_right">
                                          <span>{formatMessageTime(user.message_time)}</span>
                                          <span className="dot_sky" />
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ))
                              ) : (
                                <p className="no_list">No chat users available.</p>
                              )}
                            </div>
                        </div>
                        {priorityCount > 0 && (
                        <div
                          className="tab-pane fade"
                          id="pills-following"
                          role="tabpanel"
                          aria-labelledby="pills-following-tab"
                        >
                          {/* Content for Priority  */}
                           <div className="chat_user_list">                                 
                              {loading ? (
                                <p>Loading...</p>
                              ) : sortedUserspriority.length > 0 ? (
                                sortedUserspriority
                                  .filter((user) =>
                                    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    user.username.toLowerCase().includes(searchTerm.toLowerCase())
                                  )
                                  .map((user) => (
                                   <Link
                                      to={`/chatmessage/${user.user_id}`}
                                      className={`chate_user_block ${
                                        (user.seen === "true" && !user.is_auth_user_message) || user.is_auth_user_message ? "seen" : ""
                                      }`}
                                      key={user.user_id}
                                    >
                                    <div className="client-img">
                                      <div className="lazy-container user_image">
                                        <div className={user.user_online_status === 'online' ? 'user_online_status online' : ''}>
                                          {user.profile ? (
                                            <img src={user.profile} alt={`${user.name} Image`} />
                                          ) : (
                                            <div className="user_initials">
                                             {getInitials(user.name)} 
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="chat_message_inside_list">
                                      <div className="chat_message_top_right">
                                        <div className="chat_message_top_right_left">
                                          <span>{user.name} <img src={verified} /></span>
                                          <span className="chat_username"> @{user.username} </span>
                                        </div>
                                        <div className="chat_message_top_right_right">
                                          <div className="close_icon_chat">
                                            <svg
                                              width={54}
                                              height={54}
                                              viewBox="0 0 54 54"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M5 49L49 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M49 49L5 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat_message_bottom_right">
                                        <div className="chat_message_bottom_right_left">
                                          <ul className="list_below_name chat-inside-list">
                                            {user.media && user.media.length > 0 && !user.last_message && (
                                              <li>
                                                <svg
                                                  className="img-inside_chate"
                                                  width={38}
                                                  height={38}
                                                  viewBox="0 0 38 38"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                                    fill="#242529"
                                                  />
                                                  <circle
                                                    cx="2.7766"
                                                    cy="2.7766"
                                                    r="2.7766"
                                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                                    fill="#242529"
                                                  />
                                                  <path
                                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                                    stroke="#242529"
                                                    strokeWidth="3.39362"
                                                    strokeLinecap="round"
                                                  />
                                                </svg>
                                                Media Attached
                                              </li>
                                            )}
                                            {user.last_message && (
                                              <li>{user.last_message}</li>
                                            )}
                                          </ul>
                                        </div>
                                        <div className="chat_message_bottom_right_right">
                                          <span>{formatMessageTime(user.message_time)}</span>
                                          <span className="dot_sky" />
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ))
                              ) : (
                                <p className="no_list">No chat users available.</p>
                              )}
                            </div>
                        </div>
                        )}
                        {unreadCount > 0 && (
                        <div
                          className="tab-pane fade"
                          id="pills-trending"
                          role="tabpanel"
                          aria-labelledby="pills-trending-tab"
                        >
                          {/* Content for Unread */}
                          <div className="chat_user_list">                                 
                                {loading ? (
                                    <p>Loading...</p>
                                  ) : sortedUsersunread.length > 0 ? (
                                    sortedUsersunread
                                      .filter((user) =>
                                        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        user.username.toLowerCase().includes(searchTerm.toLowerCase())
                                      )
                                      .map((user) => (
                                   <Link
                                      to={`/chatmessage/${user.user_id}`}
                                      className={`chate_user_block ${
                                        (user.seen === "true" && !user.is_auth_user_message) || user.is_auth_user_message ? "seen" : ""
                                      }`}
                                      key={user.user_id}
                                    >
                                    <div className="client-img">
                                      <div className="lazy-container user_image">
                                        <div className={user.user_online_status === 'online' ? 'user_online_status online' : ''}>
                                          {user.profile ? (
                                            <img src={user.profile} alt={`${user.name} Image`} />
                                          ) : (
                                            <div className="user_initials">
                                             {getInitials(user.name)} 
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="chat_message_inside_list">
                                      <div className="chat_message_top_right">
                                        <div className="chat_message_top_right_left">
                                          <span>{user.name} <img src={verified} /></span>
                                          <span className="chat_username"> @{user.username} </span>
                                        </div>
                                        <div className="chat_message_top_right_right">
                                          <div className="close_icon_chat">
                                            <svg
                                              width={54}
                                              height={54}
                                              viewBox="0 0 54 54"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M5 49L49 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M49 49L5 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat_message_bottom_right">
                                        <div className="chat_message_bottom_right_left">
                                          <ul className="list_below_name chat-inside-list">
                                            {user.media && user.media.length > 0 && !user.last_message && (
                                              <li>
                                                <svg
                                                  className="img-inside_chate"
                                                  width={38}
                                                  height={38}
                                                  viewBox="0 0 38 38"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                                    fill="#242529"
                                                  />
                                                  <circle
                                                    cx="2.7766"
                                                    cy="2.7766"
                                                    r="2.7766"
                                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                                    fill="#242529"
                                                  />
                                                  <path
                                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                                    stroke="#242529"
                                                    strokeWidth="3.39362"
                                                    strokeLinecap="round"
                                                  />
                                                </svg>
                                                Media Attached
                                              </li>
                                            )}
                                            {user.last_message && (
                                              <li>{user.last_message}</li>
                                            )}
                                          </ul>
                                        </div>
                                        <div className="chat_message_bottom_right_right">
                                          <span>{formatMessageTime(user.message_time)}</span> 
                                          <span className="dot_sky" />
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ))
                              ) : (
                                <p className="no_list">No chat users available.</p>
                              )}
                            </div>
                        </div>
                        )}
                      </div>
                    </div>

                  </div>

              </div>
            </div>
            

            <div className="right_main_content chat_messages_list">
                    <div className="page_title_with_dropdown notification_page main_chat_header">
                      <div className="page_heading">
                        <button className="profile_back_btn" onClick={handleBackClick}>
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                              stroke="#222"
                              strokeWidth={6}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <div className="chat_header">
                          <h1> Chat Gallery
                          </h1>
                          <ul className="chat_header_below_list">
                            <li>
                              with {receiverDetails.name}  
                            </li>
                          </ul>
                        </div>
                      </div>                      
                      {isSearchVisibleChat && (
                      <div id="searchContainerChat" className="collection_search chat_search">
                            <button
                              id="closeButton"
                              className="create_post_btn_area verify_btn search_btn_chat close_btn_search_after"
                              onClick={closeSearchChat}
                            >
                              <svg
                                width={54}
                                height={54}
                                viewBox="0 0 54 54"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 49L49 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M49 49L5 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              className="form-control"
                              id="searchInputChat"
                              placeholder="Find in Chat"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <button>
                              <svg
                                className="heading_search_icon"
                                width={38}
                                height={38}
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                  stroke="#00aff0"
                                  strokeWidth="3.88235"
                                />
                                <path
                                  d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                  fill="#00aff0"
                                />
                              </svg> 
                          </button>
                     </div>
                      )
                    }
                    </div>
                    <div className="chat-container-gallery">
                    <div className="middle_part_chats_gallery">                  

                       <UserChatGallery receiverId={receiverId} />  

                    </div>
                    </div>  
                  </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatGallery;
